class GlobalNotificationHeaderClass {
    constructor() {
        this.main = document.getElementById('global-notification-header');
        this.layoutTemplate = `<div class="container-fluid">
            <div class="alert-message alert-message--inline alert-message--full-size alert-message--align-left py-2 container-fluid">
                <div class="alert-message__text"></div>
            </div>
        </div>`;
    }

    _cssClassForItem(type) {
        switch (type) {
            case 'warning':
                return 'background-orange-200';
            case 'success':
                return 'background-green-200';
            case 'error':
                return 'background-red-200';
            default:
                return '';
        }
    }

    reset(){
        this.main.innerHTML = '';
    }

    addNotification({ content, type = 'warning', actionSelector = null, actionCallback = null } = {}) {
        if (content) {
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = this.layoutTemplate.trim();
    
            const newItem = tempDiv.firstChild;
            const notificationItem = newItem;
            const notificationAlert = newItem.querySelector('.alert-message');
            const notificationContent = newItem.querySelector('.alert-message__text');
    
            notificationItem.classList.add(this._cssClassForItem(type));
            notificationAlert.classList.add('alert-message--'+type);
            notificationContent.innerHTML = content;
    
            if (actionSelector && typeof actionCallback === 'function') {
                const actionElement = notificationContent.querySelector(actionSelector);
                if (actionElement) {
                    actionElement.addEventListener('click', (e) => {
                        e.preventDefault();
                        actionCallback(e);
                    });
                }
            }
    
            this.main.appendChild(newItem);
        }
    }
    
}

const GlobalNotificationHeader = new GlobalNotificationHeaderClass();
Object.seal(GlobalNotificationHeader);

export default GlobalNotificationHeader;
